export default __webpack_public_path__ + "short-videoe354f0.jpg";